
import { Options, Vue } from 'vue-class-component'
import ValueRange from '@/effects/ValueRange'

@Options({
  props: {
    container: ValueRange,
    barColor: String,
    backgroundColor: String
  },
  methods: {
    log(msg: any) {
      console.log(msg)
    }
  },
  computed: {
    cssVars() {
      return {
        '--percent-filled': this.container.fraction * 100 + '%',
        '--background-color': this.backgroundColor,
        '--bar-color': this.barColor
      }
    }
  }
})
export default class ValueMeter extends Vue {
  container!: ValueRange | undefined
  backgroundColor: string = '#282c3b'
  barColor: string = '#741A32'
}
